import { buildModelManager } from "../builder.js";
const DefaultQuoteTemplateItemSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  deletedAt: true,
  description: true,
  itemType: true,
  quantity: true,
  templateId: true,
  unitPrice: true,
  updatedAt: true,
  vatRate: true
};
const modelApiIdentifier = "quoteTemplateItem";
const pluralModelApiIdentifier = "quoteTemplateItems";
;
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQuoteTemplateItemSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQuoteTemplateItemSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQuoteTemplateItemSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQuoteTemplateItemSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQuoteTemplateItemSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQuoteTemplateItemSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQuoteTemplateItemSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createQuoteTemplateItem",
    operationReturnType: "CreateQuoteTemplateItem",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      quoteTemplateItem: { required: false, type: "CreateQuoteTemplateItemInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultQuoteTemplateItemSelection
  },
  {
    type: "action",
    operationName: "bulkCreateQuoteTemplateItems",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateQuoteTemplateItemsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultQuoteTemplateItemSelection
  },
  {
    type: "action",
    operationName: "updateQuoteTemplateItem",
    operationReturnType: "UpdateQuoteTemplateItem",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      quoteTemplateItem: { required: false, type: "UpdateQuoteTemplateItemInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultQuoteTemplateItemSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateQuoteTemplateItems",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateQuoteTemplateItemsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultQuoteTemplateItemSelection
  },
  {
    type: "action",
    operationName: "deleteQuoteTemplateItem",
    operationReturnType: "DeleteQuoteTemplateItem",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteQuoteTemplateItems",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "restoreQuoteTemplateItem",
    operationReturnType: "RestoreQuoteTemplateItem",
    functionName: "restore",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      quoteTemplateItem: { required: false, type: "RestoreQuoteTemplateItemInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultQuoteTemplateItemSelection
  },
  {
    type: "action",
    operationName: "bulkRestoreQuoteTemplateItems",
    functionName: "bulkRestore",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "restore",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkRestoreQuoteTemplateItemsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultQuoteTemplateItemSelection
  },
  {
    type: "action",
    operationName: "upsertQuoteTemplateItem",
    operationReturnType: "UpsertQuoteTemplateItem",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      quoteTemplateItem: { required: false, type: "UpsertQuoteTemplateItemInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateQuoteTemplateItemResult": { hasReturnType: false },
      "... on UpdateQuoteTemplateItemResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultQuoteTemplateItemSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertQuoteTemplateItems",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertQuoteTemplateItemsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultQuoteTemplateItemSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "quoteTemplateItemGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const QuoteTemplateItemManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultQuoteTemplateItemSelection,
  operations
);
export {
  DefaultQuoteTemplateItemSelection,
  QuoteTemplateItemManager
};
//# sourceMappingURL=QuoteTemplateItem.js.map
